<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 12C0 5.38326 5.38326 0 12 0C18.6167 0 24 5.38326 24 12C24 18.6167 18.6167 24 12 24C5.38326 24 0 18.6167 0 12ZM12.0063 4.5C11.2297 4.5 10.6001 5.13847 10.6001 5.92606V13.6373C10.6001 14.4249 11.2297 15.0634 12.0063 15.0634C12.783 15.0634 13.4126 14.4249 13.4126 13.6373V5.92606C13.4126 5.13847 12.783 4.5 12.0063 4.5ZM12.0063 16.6479C11.2297 16.6479 10.6001 17.2864 10.6001 18.0739C10.6001 18.8615 11.2297 19.5 12.0063 19.5C12.783 19.5 13.4126 18.8615 13.4126 18.0739C13.4126 17.2864 12.783 16.6479 12.0063 16.6479Z"
    />
  </svg>
</template>
